import React from 'react'
import { Link } from 'react-router-dom'
import { Spinner } from '..'
import { ButtonStyled } from './styles'

const Button = ({
  children,
  name,
  variant='primary',
  size='medium',
  isFull,
  onClick= () => {},
  to,
  className,
  disabled,
  isLoading,
  iconLeft: IconLeft,
  iconRight: IconRight,
  iconSize = 24,
  openNewTab,
  weight = 'normal',
  borderRadius = 8
}) => {

  const isOnlyIcon = !children  && (!!IconLeft || !!IconRight)
  const isLink = !!to

  const linkProps = isLink && openNewTab
    ? { target:"_blank", rel:"noopener noreferrer" }
    : {}

    const handleClick = (e) => {
    if (disabled || isLoading) {
      e.preventDefault()
      return
    }
    onClick()
  }

  return (
    <ButtonStyled
      className={className}
      name={name}
      size={size}
      $isFull={isFull}
      $variant={variant}
      onClick={handleClick}
      to={to}
      as={isLink ? Link : 'button'}
      {...linkProps}
      disabled={disabled}
      $isLoading={isLoading}
      $isIcon={isOnlyIcon}
      $weight={weight}
      $borderRadius={borderRadius}
    >
      { isLoading ? (
          <>
            {children}
            <Spinner />
          </>
        ) : (
          <>
            {IconLeft && (
              <IconLeft
                height={iconSize}
                width={iconSize}
              />
            )}
            {children}
            {IconRight && (
              <IconRight
                height={iconSize}
                width={iconSize}
              />
            )}
          </>
      )}
    </ButtonStyled>
  )
}

export default Button